import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AccountService } from './account.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Container, Operator, PaymentMethod, Reason, TypeBilling, Vehicle } from '../interfaces/create-edit.interface';
import { Residue } from '../interfaces/gauging.interface';
import { Signs } from '../interfaces/person.interface';

@Injectable({
  providedIn: 'root',
})
export class ObjectsService {
  private url = `${environment.api_url}/aforo/app`;

  constructor(private http: HttpClient, private accountSrv: AccountService) {}

  getContainersActives(): Observable<Container[]> {
    let headers = this.accountSrv.headers;
    return this.http.get<Container[]>(`${this.url}/containers/?active=true`, { headers });
  }

  getOperators(): Observable<Operator[]> {
    let headers = this.accountSrv.headers;
    return this.http.get<Operator[]>(`${this.url}/operators/`, { headers });
  }

  getPaymentMethods(): Observable<PaymentMethod[]> {
    let headers = this.accountSrv.headers;
    return this.http.get<PaymentMethod[]>(`${this.url}/payment_methods/`, {
      headers,
    });
  }

  getReasons(): Observable<Reason[]> {
    let headers = this.accountSrv.headers;
    return this.http.get<Reason[]>(`${this.url}/reasons/`, { headers });
  }

  getResidues(): Observable<Residue[]> {
    let headers = this.accountSrv.headers;
    return this.http.get<Residue[]>(`${this.url}/residues/`, { headers });
  }

  getSigns(niud: string, username: string): Observable<Signs> {
    let headers = this.accountSrv.headers;
    return this.http.get<Signs>(
      `${this.url}/gauging/signs/?niud=${niud}&username=${username}`,
      { headers }
    );
  }

  getTypesBilling(): Observable<TypeBilling[]> {
    let headers = this.accountSrv.headers;
    return this.http.get<TypeBilling[]>(`${this.url}/types_billing/`, {
      headers,
    });
  }

  getVehicles(): Observable<Vehicle[]> {
    let headers = this.accountSrv.headers;
    return this.http.get<Vehicle[]>(`${this.url}/vehicles/`, { headers });
  }

  setOperators(data: any, id: number): Observable<Vehicle> {
    let headers = this.accountSrv.headers;
    return this.http.patch<Vehicle>(`${this.url}/vehicle/${id}/set_operators/`, data, { headers });
  }
}
